var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bullet"},[_c('div',{staticClass:"bullet-outer bigItUp",on:{"click":_vm.getBulletNumber}},[_c('div',{staticClass:"bullet-line"}),_vm._v(" "),_c('div',{staticClass:"bullet-name"},[_vm._v("\n      "+_vm._s(_vm.bullet.featureName)+"\n    ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48cae6e2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Bullet.vue
// module id = 40
// module chunks = 0